const list = [
    '/solicitation/personal/index',
    '/solicitation/personal/add',
    '/solicitation/personal/preview',
    '/solicitation/personal/works',
    '/solicitation/personal/worksinfo'
];

const isUrl = function (url, type) {
    let that = this,
        sym = '!=',
        noLoginUrls = '';

    if(type){
        sym = type;
    }

    for(let i = 0; i < list.length; i++){

        if(i == 0){
            noLoginUrls += `"${url}"${sym}"${list[i]}"`;
        }else if(i == list.length-1){
            noLoginUrls += `&&"${url}"${sym}"${list[i]}"`;
        }else{
            noLoginUrls += `&&"${url}"${sym}"${list[i]}"`;
        }
    }
    
    return eval(noLoginUrls);
}

export default isUrl


// WEBPACK FOOTER //
// ./src/auth/nologin.js